import { Button, Col, List, Row } from 'antd';
import React, { useState } from 'react';
import {
  updateTrainerInfo,
  uploadTrainerImage,
} from '../../../services/trainerServices';
import InterestEdit from '../Interests/InterestEdit';
import { beforeImageUpload } from '../../../utilities/imageUpload';
import DeleteWarningModalWithAction from '../../Common/DeleteWarningModalWithAction';

function MilestonesCard({
  item,
  index,
  trainer,
  updateTrainerLocalData,
  updateTrainerData,
}) {
  const [isMilestoneModalOpen, setIsMilestoneModalOpen] = useState(false);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode.',
  });

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  function toggleMilestoneEdit() {
    setIsMilestoneModalOpen((prev) => !prev);
  }

  async function onSubmit(values) {
    let milestones = trainer.milestones;
    milestones[index] = values;

    setStatus({ type: 'LOADING', message: 'Loading for request!' });
    let trainerData = {
      ...trainer,
      milestones,
    };

    await updateTrainerInfo(trainer.trainerId, trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  const initialValues = {
    title: item.title,
    imageLink: item.imageLink,
    description: item.description,
  };

  const onImageUpload = async (e) => {
    const milestones = trainer.milestones;
    const currentMilestone = milestones[index];
    const formData = new FormData();
    formData.append('name', `${currentMilestone.title}`);
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'assets')
      .then((res) => {
        currentMilestone.imageLink = res.data.imageUrl;
        milestones[index] = currentMilestone;
        const trainerData = { ...trainer, ...{ milestones } };
        updateTrainerLocalData(trainerData);
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const onDelete = async () => {
    trainer.milestones.splice(index, 1);
    const milestones = trainer.milestones;
    const trainerData = { ...trainer, ...{ milestones } };
    await updateTrainerData(trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successfully deleted field' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <div>
      <List.Item
        key={item.title}
        extra={
          <img width={272} height={180} alt="milestones" src={item.imageLink} />
        }
      >
        <List.Item.Meta
          title={
            <Row justify="space-between">
              {item.title}
              <Col>
                <Button
                  onClick={toggleMilestoneEdit}
                  style={{ marginRight: '8px' }}
                >
                  Edit
                </Button>
                <Button onClick={() => setIsDeleteModalVisible(true)}>
                  Delete
                </Button>
              </Col>
            </Row>
          }
          description={<a href={item.imageLink}>{item.imageLink}</a>}
        />
        {item.description}
      </List.Item>
      <InterestEdit
        type="UPDATE"
        initialValues={initialValues}
        isOpen={isMilestoneModalOpen}
        status={status}
        toggle={toggleMilestoneEdit}
        onSubmit={onSubmit}
        onImageUpload={onImageUpload}
        beforeImageUpload={beforeImageUpload}
      />
      <DeleteWarningModalWithAction
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        action={onDelete}
      />
    </div>
  );
}

export default MilestonesCard;
